import React from "react";

export default function SectionCard({
  icon: Icon,
  title,
  subtitle,
  action,
  children,
  className = "",
}) {
  return (
    <section
      className={`overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm shadow-slate-200/60 dark:border-slate-800 dark:bg-slate-900 dark:shadow-none ${className}`}
    >
      {(title || subtitle || action) && (
        <div className="flex flex-col gap-4 border-b border-slate-200 px-5 py-5 dark:border-slate-800 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex min-w-0 gap-3">
            {Icon && (
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:text-orange-300">
                <Icon className="text-lg" />
              </span>
            )}

            <div className="min-w-0">
              {title && (
                <h2 className="text-lg font-bold text-slate-950 dark:text-white">
                  {title}
                </h2>
              )}

              {subtitle && (
                <p className="mt-1 text-sm leading-6 text-slate-500 dark:text-slate-400">
                  {subtitle}
                </p>
              )}
            </div>
          </div>

          {action && <div className="shrink-0">{action}</div>}
        </div>
      )}

      <div className="p-5">{children}</div>
    </section>
  );
}